import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    syncLogsGrid: {
        margin: theme.spacing(1),
    },
    forceSyncGrid: {
        margin: theme.spacing(1),
        marginBottom: 0,
        textAlignLast: 'right',
    },
    forceSyncButton: {
        marginTop: 10,
    },
    addNewFolderButton: {
        marginBottom: 10,
    },
    verticalAlignItem: {
        verticalAlign: 'middle',
    },
    deleteButton: {
        minWidth: 24,
        maxWidth: 30,
        padding: '4px 5px',
    },
    deleteButtonIcon: {
        fontSize: 16,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    baseFontAwesomeIcon: {
        margin: 'auto',
        fontSize: 20,
        width: 20,
        height: 20,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    infoButtonIconDownload: {
        float: 'right',
        paddingRight: 8,
        color: '#2196f3',
    },
    infoButtonIconErrors: {
        float: 'left',
        paddingLeft: 8,
    },
    downloadButtonIcon: {
        paddingLeft: '4%',
        color: '#8DD9C8',
    },
    dateTimePicker: {
        marginRight: '15px',
        marginLeft: '8px',
    },
    dialog: {
        '& .k-dialog': {
            '& .k-dialog-content': {
                marginTop: theme.spacing(2),
            },

            '& .k-dialog-titlebar': {
                backgroundColor: '#8DD9C8',
                fontSize: '1em',
            },
            '& .k-form-buttons': {
                justifyContent: 'flex-end',
            },
            '& .k-window-title': {
                fontSize: '1.4em',
                backgroundColor: '#8DD9C8',
            },
            '& .k-step-label': {
                '& .k-step-text': {
                    display: 'block',
                    whiteSpace: 'normal',
                },
            },
        },
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '4%',
    },
    selectedFoldersTitle: {
        fontSize: '1.5em',
        paddingBottom: '1.5em',
    },
    selectedFolders: {
        paddingTop: '1%',
        paddingLeft: '2%',
        overflowY: 'auto',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
    },

    gridHeight: {
        '& .k-grid-container': {
            maxHeight: '53vh',
        },
    },
    confirmationDialog: {
        display: 'flex',
        justifyContent: 'center',
    },
    buttonGridAction: {
        display:'inline-block',
        margin: 'auto 5px'
    }
}));

export default useStyles;
